import React from 'react';
import PropTypes from 'prop-types';
import {withRouter, routerShape, locationShape} from 'react-router';
import {suspectInfiniteLoop} from 'spa/debug';

import DocumentMeta from './DocumentMeta';

const isServer = typeof window === 'undefined';

let redirectLocation;

@withRouter
class Go extends React.Component {
  static propTypes = {
    replace: PropTypes.bool,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    router: routerShape.isRequired,
    location: locationShape.isRequired,
    statusCode: PropTypes.number,
    forceReload: PropTypes.bool,
  };
  static defaultProps = {
    statusCode: 302,
  };

  UNSAFE_componentWillMount() {
    this.redirect(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.to !== this.props.to) {
      this.redirect(nextProps);
    }
  }

  @suspectInfiniteLoop
  redirect({
    to, replace, router, location, statusCode, forceReload,
  }) {
    if (!router) return; // WTF!

    if (isServer) {
      let url;
      if (typeof to === 'string') {
        url = to;
      } else {
        url = router.createHref(to);
      }
      redirectLocation = {
        pathname: url,
        search: '',
        statusCode,
      };
    } else {
      if (forceReload) {
        window.location.href = router.createHref(to);
        return;
      }
      to = router.createLocation(to);
      if (
        to.pathname === location.pathname &&
        to.search === location.search
      ) {
        throw new Error(`<Go> shouldn't be used to redirect to the same page`);
        // do nothing
        // return;
      }
      router[replace ? 'replace' : 'push'](to);
    }
  }

  render() {
    if (!isServer) {
      return null;
    }

    const {to, router} = this.props;
    if (!router) return null; // WTF!
    let url;
    if (typeof to === 'string') {
      url = to;
    } else {
      url = router.createHref(to);
    }
    return (
      <DocumentMeta meta={{httpEquiv: { refresh: `0; url=${url}`}}} />
    );
  }
}

export default Go;

export function rewindRedirectLocation() {
  const _redirectLocation = redirectLocation;
  redirectLocation = null;
  return _redirectLocation;
}



// WEBPACK FOOTER //
// ./spa/Components/Go.jsx